// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"_2RYSwJVHRNVU_GkkNmB65Y","checked":"_3XNyHD5GYkJx7tfon_rpR3","checkbox":"_1WZCt9R0aV59Wo9CclfhyD"};